(function() {
  'use strict';

  angular.module('tf.retailer.Util')
      .factory('ChartUtil', ChartUtil);

  function ChartUtil(){
    return {
      chartDateParser: d3.time.format("%Y-%m-%d").parse,
      dateLabelFormat: d3.time.format("%m, %d %Y")
    }

  }


})();